import React from 'react';

export class AreaIcon extends React.PureComponent {
  render() {
    return (
      <svg width="120" height="100" viewBox="0 0 120 100" {...this.props}>
        <g fillRule="nonzero" fill="none">
          <path
            d="M29.863 89.55L0 100V10.616L29.327.353 29.391 0l.472.166.474-.166v.333l29.032 10.22L88.764 0v.986L88.941 0l30.16 10.616V100l-30.16-10.616-.177-.986v.986L59.551 99.87V100l-.182-.064-.179.064-.015-.132L29.863 89.55z"
            fill="#929DB3"
            fillOpacity=".25"
          />
          <path
            d="M35.515 31.748a2 2 0 0 1 2.314-2.22l45 7.5a2 2 0 0 1 1.653 2.236l-3.75 28.125a2 2 0 0 1-1.473 1.67l-35.625 9.375a2 2 0 0 1-2.494-1.686l-5.625-45zm4.302 2.166l5.01 40.07 32.118-8.452 3.317-24.877-40.445-6.741z"
            fill="#B0B4B9"
          />
          <path
            d="M90 39a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0zM45 31.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0zM50.625 76.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0zM86.25 67.125a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0z"
            fill="currentColor"
            style={{
              mixBlendMode: 'multiply',
            }}
          />
          <path
            fill="#FFF"
            d="M35.625 29.625h3.75v3.75h-3.75zM80.625 37.125h3.75v3.75h-3.75zM76.875 65.25h3.75V69h-3.75zM41.25 74.625H45v3.75h-3.75z"
          />
        </g>
      </svg>
    );
  }
}
